const StartMenu = [
    {subName:'소개'},
    {subName:'규칙'}
]

const SoftwareMenu = [
    {subName:'명칭 및 기능'},
    {subName:'시스템 상태표시'}
]

const GearMenu = [
    {subName:'기능 설명'},
    {subName:'입출력 신호 연결'},
    {subName:'프로그램 실행'},
    {subName:'입력 출력 설정'},
    {subName:'입출력 바이패스 설정'},
    {subName:'VIDEO MIXER'},
    {subName:'LIVE 입력 영상 송출'},
    {subName:'NET & USB'},
    {subName:'동영상 재생 송출'},
    {subName:'이미지,PPT 송출'},
    {subName:'PC 화면 송출'},
    {subName:'단문 메시지 송출'},
    {subName:'AUDIO MIXER'},
    {subName:'배경 오디오 설정'},
    {subName:'Play List 순서 송출'},
    {subName:'예약 송출'},
    {subName:'동영상 녹화'},
    {subName:'원격'}
]

export {StartMenu,GearMenu,SoftwareMenu};